import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DialogEdit from "./DialogEdit";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonEdit({ item, session, reloadData }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>     
      
        {item?(
          <IconButton onClick={handleOnOpen}>
            <EditIcon/>
          </IconButton>      
        ):(
          <IconButton onClick={handleOnOpen}>
            <AddIcon/>
          </IconButton>          
        )}
      
      <DialogEdit
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        item={item}
        session={session}
        reloadData={reloadData}
      />
    </>
  );
}
